import { Injectable } from '@angular/core';
import { CryptoService } from '@nexa/encryption';
import { environment } from 'apps/website/src/environments/environment';
import { Observable, from } from 'rxjs';

/**
 * Servicio encargado del proceso de criptografía
 */
@Injectable()
export class EncryptService {

  /**
   * Llave privada
   */
  private readonly key = environment.signingAesKey;

  /**
   * Servicio de encriptacion
   */
  private readonly nexaEncryptionService: CryptoService;

  /**
   * Crea una instancia EncryptService
   */
  public constructor(nexaEncryptionService: CryptoService) {
    this.nexaEncryptionService = nexaEncryptionService;
  }

  /**
   * Metodo encargado de encriptar informacion usando AES GCM 256
   */
  public toEncrypt(data: string): Observable<string> {
    return from(this.nexaEncryptionService.encryptData(this.key, data));
  }

  /**
   * Metodo encargado de desencriptar informacion usando AES GCM 256
   */
   public toDecrypt(data: string): Observable<string> {
    return from(this.nexaEncryptionService.decryptData(this.key, data));
  }
}
